import React, { useState } from 'react';
import { LuBus, LuTruck } from 'react-icons/lu';
import { Segmentado } from './Pantalla';

// Colectivo o camioneta (23-oct-2026): cambia tiempos, costo del viaje y, en camioneta con una empresa
// que tiene depósito, el punto de salida. Se acuerda de la última elección en este navegador.
const CLAVE = 'medio-viaje';
export const OPCIONES_MEDIO = [{ id: 'COLECTIVO', label: 'Colectivo', icono: LuBus }, { id: 'CAMIONETA', label: 'Camioneta', icono: LuTruck }];

export function useMedioViaje(inicial = null) {
    const [medio, setMedio] = useState(() => {
        if (inicial) return inicial;
        try { return localStorage.getItem(CLAVE) || 'COLECTIVO'; } catch { return 'COLECTIVO'; }
    });
    const cambiar = (m) => { setMedio(m); try { localStorage.setItem(CLAVE, m); } catch { /* sin storage */ } };
    return [medio, cambiar];
}

export default function MedioViaje({ valor, onChange }) {
    return <Segmentado valor={valor} onChange={onChange} opciones={OPCIONES_MEDIO.map(o => ({ id: o.id, label: o.label }))} />;
}
